import PN from "persian-number";
import { Controller } from "react-hook-form";

import { cn } from "../../utils/utils";

const RegexCustomInput = (props) => {
  const {
    control,
    name,
    label,
    errors,
    placeholder,
    className,
    disabled,
    tabIndex,
    type,
    regexPattern,
    errorMessage = "",
    setValue,
    setError,
    clearErrors,
  } = props;

  const handleValueChange = (value) => {
    const lastChar = value.slice(-1);

    if (!regexPattern.test(lastChar) && lastChar !== "") {
      setError(name, {
        type: "manual",
        message: errorMessage,
      });

      const newValue = value.slice(0, -1);
      setValue(name, newValue);
    } else {
      clearErrors(name);
      setValue(name, PN.convertPeToEn(value));
    }
  };

  return (
    <div className={cn("col-span-2 md:col-span-1 flex flex-col gap-2 ", className)}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <label htmlFor={name} className="text-[14px] md:text-[16px]">
              {label}
            </label>
            <input
              autoFocus={false}
              tabIndex={tabIndex || "0"}
              className="h-[52px] text-[14px] md:text-[16px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
              disabled={disabled}
              type={type}
              placeholder={placeholder}
              value={value}
              onBlur={onBlur}
              onChange={(e) => handleValueChange(e.target.value)}
              onWheel={(e) => e.target.blur()}
            />
            {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
          </>
        )}
      />
    </div>
  );
};

export default RegexCustomInput;
